var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "FiltersContainer",
    { attrs: { title: "Filters" }, on: { click: _vm.handleReset } },
    [
      [
        _c("FormGroup", {
          attrs: {
            debounceTime: _vm.inputDebounceTime,
            title: "Job Title",
            placeholder: "Enter title",
          },
          model: {
            value: _vm.jobTitle,
            callback: function ($$v) {
              _vm.jobTitle = $$v
            },
            expression: "jobTitle",
          },
        }),
        _c(
          "FormGroup",
          { attrs: { title: "Skills" } },
          [
            _c("SkillsMultiselect", {
              model: {
                value: _vm.skillsIds,
                callback: function ($$v) {
                  _vm.skillsIds = $$v
                },
                expression: "skillsIds",
              },
            }),
          ],
          1
        ),
        _c(
          "FormGroup",
          { attrs: { title: "Status" } },
          [
            _c("CustomRequestStatusMultiselect", {
              model: {
                value: _vm.statusIds,
                callback: function ($$v) {
                  _vm.statusIds = $$v
                },
                expression: "statusIds",
              },
            }),
          ],
          1
        ),
        _vm.showManagerFilter
          ? _c(
              "FormGroup",
              { attrs: { title: "Managers" } },
              [
                _c("ManagersMultiselect", {
                  model: {
                    value: _vm.managerIds,
                    callback: function ($$v) {
                      _vm.managerIds = $$v
                    },
                    expression: "managerIds",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }